import { Paper } from "@material-ui/core";
import Authorize from "../../../../components/Authorize";
import { permissionProfiles } from "../../../../components/Authorize/permissionProfiles";
import ContractHeader from "../../contracts/ContractHeader/ContractHeader";
import configStyles from "../configStyles";
import DisabledContract from "../DisabledContract";
import WashCycleConfig from "./WashCycleConfig";

const useStyles = configStyles;

const WashConfig = ({
    clientToEdit,
    onConfigChange,
    configName = 'washConfig',
    cycleFields,
    onChangeCycleField
}) => {
    const classes = useStyles();
    const washConfigParams = clientToEdit?.config?.washConfig;

    return (
        <>
            <ContractHeader
                label={'Wash Program'}
                flag={washConfigParams?.useWashProgram}
                onChange={() => {
                    onConfigChange(configName, "useWashProgram", !washConfigParams?.useWashProgram)
                }}
            />
            {!washConfigParams?.useWashProgram && <Authorize profile={permissionProfiles.CLIENT_CONFIG.CONTRACT_OFF_CLIENT}>
                <DisabledContract contractName={'wash program'} />
            </Authorize>}
            <Authorize profile={washConfigParams?.useWashProgram ? permissionProfiles.CLIENT_CONFIG.CONTRACT_ON : permissionProfiles.CLIENT_CONFIG.CONTRACT_OFF}>
                <div>
                    <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_FIELD_EDIT}>
                        <Paper className={classes.card}>
                            <ContractHeader
                                label={'Wash Cycle Configuration'}
                            />
                            <WashCycleConfig
                                disabled={!washConfigParams?.useWashProgram}
                                cycleFields={cycleFields}
                                onChangeCycleField={onChangeCycleField}
                            />
                        </Paper>
                    </Authorize>
                </div>
            </Authorize>
        </>
    )
}
export default WashConfig;

